import React from 'react';
import { ChevronRight, ArrowRight } from 'lucide-react';

const SolutionsSection = ({ onNavigate }) => {
  const solutions = [
    {
      id: 'family',
      title: 'Family & Individual Solutions',
      description:
        'Thoughtful insurance solutions designed to help individuals and families plan for education, income, retirement, and long-term financial security.',
      image: process.env.PUBLIC_URL + '/images/service-life.jpeg',
      bullets: [
        'Family Secure Plan',
        'Children Education / KG–PG Scheme',
        'Pension & Income Solutions',
      ],
    },
    {
      id: 'msme',
      title: 'MSME & Corporate Insurance',
      description:
        'Risk-management solutions designed to support business continuity, protect key interests, and strengthen the long-term sustainability of your business.',
      image: process.env.PUBLIC_URL + '/images/service-msme.jpg',
      bullets: [
        'Partnership Insurance',
        'Key Man Insurance',
        'Group Insurance',
        'Employer–Employee Insurance',
      ],
    },
    {
      id: 'support',
      title: 'Policy Servicing & Support',
      description:
        'Ongoing support for policy updates, documentation, premium-related needs, claims, nominations, and other policy service requirements.',
      image: process.env.PUBLIC_URL + '/images/service-policy.jpg',
      bullets: [
        'Policy Updates',
        'Nomination & Beneficiary Changes',
        'Premium & Policy Support',
        'Claim Assistance',
      ],
    },
    {
      id: 'health',
      title: 'Health & Medical Solutions',
      description:
        'Comprehensive medical protection for individuals and families, covering hospitalizations, critical illnesses, and wellness needs.',
      image: process.env.PUBLIC_URL + '/images/service-health.jpg',
      bullets: [
        'Family Floater Mediclaim',
        'Critical Illness Protection',
        'Senior Citizen Health Cover',
        'Cashless Hospitalization Network',
      ],
    },
    {
      id: 'motor',
      title: 'Motor & Vehicle Insurance',
      description:
        'Complete road protection covering private cars, two-wheelers, and commercial fleets with quick claims and roadside assistance.',
      image: process.env.PUBLIC_URL + '/images/service-auto.jpg',
      bullets: [
        'Comprehensive Car Insurance',
        'Two-Wheeler Protection',
        'Commercial Vehicle Coverage',
        '24x7 Roadside Assistance',
      ],
    },
    {
      id: 'property',
      title: 'Property & Home Protection',
      description:
        'Safeguard your home, structure, and valuable possessions against unexpected fire, burglary, natural calamities, and property risks.',
      image: process.env.PUBLIC_URL + '/images/service-home.jpg',
      bullets: [
        'Home Building & Structure Cover',
        'Contents & Valuable Protection',
        'Fire & Natural Perils Cover',
        'Burglary & Theft Insurance',
      ],
    },
  ];

  return (
    <section className="solutions-section-container" id="solutions">
      <div className="solutions-content-wrapper">
        
        {/* Section Title */}
        <h2 className="solutions-main-title">
          INSURANCE &amp; RISK MANAGEMENT SOLUTIONS
        </h2>

        {/* 3 Column Cards Grid */}
        <div className="solutions-cards-grid">
          {solutions.map((item) => (
            <div key={item.id} className="solution-card">
              
              {/* Card Image */}
              <div className="solution-img-box">
                <img src={item.image} alt={item.title} className="solution-img" />
              </div>

              {/* Title & Description */}
              <h3 className="solution-card-title">{item.title}</h3>
              <p className="solution-card-desc">{item.description}</p>

              {/* Bottom Section: Bullet Points & Arrow Action Icon */}
              <div className="solution-card-bottom">
                <ul className="solution-bullets-list">
                  {item.bullets.map((bullet, index) => (
                    <li key={index} className="bullet-item">
                      <ChevronRight size={16} className="bullet-chevron" />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>

                <div
                  className="solution-card-arrow"
                  onClick={() => onNavigate && onNavigate('services')}
                  role="button"
                  tabIndex={0}
                  title="View services"
                >
                  <ArrowRight size={20} />
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
